export enum SettingsPermissions {
  General = 'settings-general',
  Dossier = 'dossier',
}